import { createIntl } from 'react-intl-next';
import { convertToInlineCss } from '@atlaskit/editor-common/lazy-node-view';
import { browser, timestampToString } from '@atlaskit/editor-common/utils';
import { ZERO_WIDTH_SPACE } from '@atlaskit/editor-common/whitespace';
import { fg } from '@atlaskit/platform-feature-flags';
import { N30A, N800 } from '@atlaskit/theme/colors';
import { getDateInformation } from './utils';
var intlRef;
export var dateNodeSpec = function dateNodeSpec(node) {
  intlRef = intlRef || createIntl({
    locale: document.documentElement.lang || 'en-US'
  });
  var timestamp = node.attrs.timestamp;
  var displayString = timestampToString(timestamp, intlRef);
  var wrapperAttrs = {
    class: 'date-lozenger-container',
    'data-node-type': 'date',
    'data-timestamp': timestamp,
    'aria-busy': 'true'
  };
  var attrs = {
    style: convertToInlineCss({
      // Taken from @atlaskit/date Component
      backgroundColor: "var(--ds-background-neutral, ".concat(N30A, ")"),
      color: "var(--ds-text, ".concat(N800, ")"),
      borderRadius: "var(--ds-radius-small, 4px)",
      padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-050, 4px)"),
      margin: '0 1px'
    })
  };
  return ['span', wrapperAttrs, ['span', attrs, displayString]];
};
export var dateToDOM = function dateToDOM(node, state, getPos, intl) {
  var timestamp = node.attrs.timestamp;
  var pos = getPos === null || getPos === void 0 ? void 0 : getPos();
  var _getDateInformation = getDateInformation(timestamp, intl, state, pos),
    displayString = _getDateInformation.displayString,
    color = _getDateInformation.color;
  var nodeWrapperAttrs = {
    contenteditable: 'false',
    timestamp: timestamp,
    class: 'dateView-content-wrap inlineNodeView',
    'data-prosemirror-content-type': 'node',
    'data-prosemirror-node-name': 'date',
    'data-prosemirror-node-inline': 'true',
    draggable: 'true'
  };
  if (fg('platform_editor_adf_with_localid')) {
    nodeWrapperAttrs['data-local-id'] = node.attrs.localId;
  }
  var wrapperAttrs = {
    class: 'date-lozenger-container',
    'data-node-type': 'date',
    'data-timestamp': timestamp
  };
  var attrs = {
    class: !color ? '' : "date-node-color-".concat(color),
    style: "white-space: unset"
  };
  return ['span', nodeWrapperAttrs, ['span', {
    class: 'zeroWidthSpaceContainer'
  }, ['span', {
    class: 'inlineNodeViewAddZeroWidthSpace'
  }, ZERO_WIDTH_SPACE]], ['span', wrapperAttrs, ['span', attrs, displayString]], browser.android ? ['span', {
    class: 'zeroWidthSpaceContainer',
    contentEditable: 'false'
  }, ['span', {
    class: 'inlineNodeViewAddZeroWidthSpace'
  }, ZERO_WIDTH_SPACE]] : ['span', {
    class: 'inlineNodeViewAddZeroWidthSpace'
  }, '']];
};